const ProjectsData = [
  {
    id: "project-ketchup",
    title: "Ketchup",
    url: "https://theketchupcorner.netlify.app/",
    github: "https://github.com/jordung/ketchup",
    subheader: "Unlocking Seamless Team Communication",
    description:
      ": Teaming up with a project partner, we created a platform with asynchronous stand-up capabilities. Our app transcends geographical boundaries and time zones, elevating collaborating with features like ticket tracking, document management, and real-time reactions to each other's posts. ",
    image1: require("../assets/ketchup/ketchup1.png"),
    image2: require("../assets/ketchup/ketchup2.png"),
    image3: require("../assets/ketchup/ketchup3.png"),
    image4: require("../assets/ketchup/ketchup4.png"),
    tags: ["react", "sequelize", "axios", "express", "bcrypt"],
  },
  {
    id: "project-handshake",
    title: "Handshake",
    url: "https://project-handshake.netlify.app/",
    github: "https://github.com/jordung/project-handshake",
    subheader: "Empowering Volunteers, Connecting Communities",
    description:
      ": Working in collaboration wtih a partner, we developed a platform that bridges the gap between volunteers and community service opportunities. Our app streamlines event registration for volunteers while offering admin tools for a hassle-free confirmation process.",
    image1: require("../assets/handshake/handshake1.png"),
    image2: require("../assets/handshake/handshake2.png"),
    image3: require("../assets/handshake/handshake3.png"),
    image4: require("../assets/handshake/handshake4.png"),
    tags: ["react", "sequelize", "axios", "express", "auth0"],
  },
  {
    id: "project-munch",
    title: "Munch",
    url: "https://munch-m.web.app/",
    github: "https://github.com/jteohn/munch",
    subheader: "Elevating Wellness",
    description:
      ": Developed collaboratively by a team of 3, our app empowers users to adopt a healthier lifestyle with ease, offering valuable insights into their health through calorie tracking, meal logging, and curated recipes.",
    image1: require("../assets/munch/munch1.png"),
    image2: require("../assets/munch/munch2.png"),
    image3: require("../assets/munch/munch3.png"),
    image4: require("../assets/munch/munch4.png"),
    tags: ["react", "firebase", "MUI"],
  },
  {
    id: "project-notes",
    title: "Notes.",
    url: "https://jteohn.github.io/project1-bootcamp/",
    github: "https://github.com/jteohn/project1-bootcamp",
    subheader: "Enhancing Productivity",
    description:
      ": With a focus on simplicity and efficiency, users can access their notes on the go. Whether you're jotting down ideas, creating to-do-lists, or keeping important information at your fingertips, the app provides a comfortable environment for all your note-taking needs.",
    image1: require("../assets/notes/notes1.png"),
    image2: require("../assets/notes/notes2.png"),
    image3: require("../assets/notes/notes3.png"),
    image4: require("../assets/notes/notes4.png"),
    tags: ["HTML", "CSS", "JavaScript"],
  },
];

export default ProjectsData;
